<template>
    <div class="contais">
        <div id="print">
            <span class="con_titles">
                <h2>典 当 告 知 书</h2>
            <h3>(当物来源承诺书)</h3>
            </span>
            <span class="text_con">
                尊敬的当户：
            </span>
            <div class="text_con">
                为保障当户与典当行权益，典当前请您知悉：
                <div>
                    一、典当是短期高费息借贷行为，逾期续/赎当，我行按《典当管理办法》最高标准动产典当按月综合费率4.2%，月典当利息按同期LPR折算，当户遵守当票期限、费率、典当须知约定。典当会员可适用会员费率。
                </div>
                <div>
                    二、当户须成年人且保证当物来源合法。若隐瞒当物非法来源、利用典当销赃、变现，不得办理典当；若发现当物涉嫌违法犯罪所得或属违禁品，我行向公安部门举报。
                </div>
                <div>
                    三、当物价值受多种因素影响；续当前，典当行须重新对当物估价，如当物估价贬值，典当行有权要求当户在续当前归还差额当金或赎回当物。
                </div>
                <div>
                    四、关于绝当处置：当户逾期满5天为绝当。按典当监管部门的通知要求，当户 : <span class="tex">{{NewDatas.name}}   </span>   （是否同意）与典当行按当物估价协议采取折价变卖的方式及时处理绝当物，所得价款优先清偿综合费息、当金；当金3万元以上的绝当物，当户同意按3万以下绝当品折价变现处置，无须通过拍卖处置变现。
                </div>
                <div>
                    五、赎当须由当户本人出示有效证件并交回当票原件；当票遗失，须按10元/张办理挂失。本告知书是当票、《典当须知》的重要补充，绝当处置方式约定以此为准，当户建当前请清楚理解本告知。您若不能接受本告知内容，请停止办理典当。
                </div>
                <div>
                    如您清楚并接受告知内容且保证当物来源合法，请签字确认办理典当。
                </div>

                <div>
                    <div class="footers">
                         <span >典当行：<span class="tex">{{$store.state.name}}</span> </span>
                    <span >当户：<span class="tex">{{NewDatas.name}}</span></span>
                    </div>
                   <div class="footers">
                    <span>
                        当票号：<span  class="tex">{{NewDatas.ticketnumber}}</span>
                    </span>
                    <span >
                        电话：<span class="tex">{{NewDatas.telnumber}}</span>
                    </span>
                   </div>
                </div>

                <div class="footer_date">
                    <span>年</span>
                    <span>月</span>
                    <span>日</span>
                </div>

            </div>
            
        </div>

         <el-button type="primary" v-print="'#print'">打印</el-button>
    </div>
</template>
<script>
export default {
    name:"PrintNotification",
    data() {
        return {
            
        }
    },
    props:['NewDatas'],
    methods: {
        
    },
    created() {
        
    },
    mounted() {
        setTimeout(()=>{
            console.log(this.NewDatas)
        },1000)
    },
}
</script>
<style scoped>
.con_titles{
    text-align: center;
}
.text_con{
    font-size: 16px;
}
.text_con div{
    margin: 15px 0;
}
.footers{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}
.footer_date{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
.footer_date span{
    margin: 0 20px;
}
.tex{
    text-decoration:underline
}
</style>